module.exports = __webpack_public_path__ + "img/box5.8d0d03e9.png";